<template>
  <div>
    <w-tool-tabs class="tab-button" v-model="activeTab">
      <div slot="tool" class="vertical-center-box">
        <span class="mr-r4">가상화센터명</span>
        <el-select v-model="selectedVirtualcenter" value-key="virtualcenterGroupId" @change="activeTabLoad">
          <el-option v-for="item in virtualcenterList" :key="item.virtualcenterGroupId" :label="item.label" :value="item"></el-option>
        </el-select>
      </div>
      <el-tab-pane v-for="tab in tabList" :key="tab.name" :label="tab.label" :name="tab.name" class="h100 w100">
        <component :is="tab.name" :selected-virtualcenter="selectedVirtualcenter.virtualcenterGroupId" :active-tab="activeTab" :rule-info="ruleInfo" :ref="tab.name"></component>
      </el-tab-pane>
    </w-tool-tabs>
  </div>
</template>

<script>
import RuleAPI from '@/api/settings/common/rule';
import DeviceRegistrationVmsAPI from '@/api/settings/common/device-registration-vms';
import WVirtualMachine from './components/VirtualMachine';
import WHostSetting from './components/HostSetting';
import WStorageSetting from './components/StorageSetting';
import WHostClusterSetting from './components/HostClusterSetting';
import WStorageClusterSetting from './components/StorageClusterSetting';

export default {
  name: 'WManagementDeviceRegistration',
  components: {
    WVirtualMachine,
    WHostSetting,
    WStorageSetting,
    WHostClusterSetting,
    WStorageClusterSetting,
  },
  watch: {
    activeTab() {
      this.activeTabLoad();
    },
  },
  data() {
    return {
      tabList: [
        { label: 'VM 및 템플릿', name: 'WVirtualMachine' },
        { label: '호스트', name: 'WHostSetting' },
        { label: '스토리지', name: 'WStorageSetting' },
        { label: '호스트 클러스터', name: 'WHostClusterSetting' },
        { label: '스토리지 클러스터', name: 'WStorageClusterSetting' },
      ],
      activeTab: 'WVirtualMachine',
      selectedVirtualcenter: { virtualcenterGroupId: null },
      virtualcenterList: null,
      rscEventRuleList: null,
      eventAlarmRuleList: null,
    };
  },
  computed: {
    ruleInfo() {
      return {
        rscEventRuleList: this.rscEventRuleList,
        eventAlarmRuleList: this.eventAlarmRuleList,
      };
    },
  },
  methods: {
    loadData() {
      RuleAPI.getRscEventRules().then((response) => {
        this.rscEventRuleList = response.data.data;
      });
      RuleAPI.getEventAlarmRulesByManagetypeId('VMS').then((response) => {
        this.eventAlarmRuleList = response.data.data;
      });
      DeviceRegistrationVmsAPI.getVirtualCenterList().then((response) => {
        this.virtualcenterList = response.data.data;
        if (this.virtualcenterList.length === 0) {
          this.initTab();
        } else {
          this.selectedVirtualcenter = this.virtualcenterList[0];
        }
        this.activeTabLoad();
      });
    },
    initTab() {
      this.selectedVirtualcenter = { virtualcenterGroupId: null };
      this.activeTab = 'WVirtualMachine';
    },
    activeTabLoad() {
      this.$nextTick(() => {
        const activeTab = this.activeTab;
        const activeCmp = this.$refs[activeTab];
        if (activeCmp.length > 0) {
          this.$refs[activeTab][0].loadData();
        } else {
          this.activeTab = this.tabList[0].name;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Virtual/ManagementDeviceRegistration.vue